import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import { getStripeKey } from '../../utilities/qrcode'
import BankTopup from './BankTopup'
import TopupTransactions from './TopupTransactions'

const stripePromise = loadStripe(getStripeKey())

const Topup = () => {
	return (
		<div className="page-content">
			<div className="page-header">
				<div className="page-title">
					<h3>
						<i className="fad fa-usd-circle" /> &nbsp;เติมเงิน
					</h3>
				</div>
			</div>

			<div className="row">
				<div className="col-md-6">
					<Elements stripe={stripePromise}>
						<BankTopup />
					</Elements>
				</div>
				<div className="col-md-6">
					<TopupTransactions />
				</div>
			</div>
		</div>
	)
}

export default Topup
